<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="boltType_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Bolt Type -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.BOLT_TYPE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #boltType_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BOLT_TYPE' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="boltType"
        name="boltType"
        class="input-select"
        [class.spinner]="loading"
        (selectionChange)="selectBoltType($event)"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let x of optionList | keyvalue" [value]="x.value">{{ x.key }}</mat-option>
    </mat-select>
</div>
